const MainRoutes = {
  path: "/main",
  meta: {
    requiresAuth: true,
  },
  redirect: "/main",
  component: () => import("@/layouts/FullLayout.vue"),
  children: [
    {
      path: "/",
      redirect: "/dashboard",
    },
    { name: "Dashboard", path: "/dashboard", component: () => import("@/views/Dashboard.vue") },
    {
      name: "Dossiers",
      path: "/files",
      component: () => import("@/views/Files.vue"),
    },
    {
      name: "Service Providers",
      path: "/service-providers",
      component: () => import("@/views/ServiceProviders.vue"),
    },
    {
      name: "Clients",
      path: "/clients",
      component: () => import("@/views/Clients.vue"),
    },
    {
      name: "Utilisateurs",
      path: "/users",
      component: () => import("@/views/Users.vue"),
    },
    {
      name: "User",
      path: "/user",
      component: () => import("@/views/UserInfos.vue"),
    },
    {
      name: "Emails",
      path: "/emails",
      component: () => import("@/views/Emails.vue"),
    },
    {
      name: "Eligible Works",
      path: "/eligible-works",
      component: () => import("@/views/EligibleWorks.vue"),
    },
  ],
}

export default MainRoutes
